import { getUrlParam } from './url';
/**
 * 拿到当前用户的vin
 * @returns
 */
export function getVin(): string {
  const urlvin = getUrlParam('vin') || getUrlParam('VIN');
  if (urlvin) {
    return urlvin;
  }

  const storagevin = localStorage.getItem('MTN_BI_REPORT_VIN');
  if (storagevin) {
    return storagevin;
  }

  const vin = (() => {
    const chars = 'abcdefjkijklmnopqrstuvwxyz';
    const max = chars.length;
    let vin = '';
    for (let i = 0; i < 16; i++) {
      vin += chars.charAt(Math.floor(Math.random() * max));
    }
    return vin;
  })();
  localStorage.setItem('MTN_BI_REPORT_VIN', vin);
  return vin;
}
